import { FC, useState, createContext } from 'react';
type SidebarContext = { 
  sidebarToggle: any; 
  toggleSidebar: () => void;
  sidebarCollapsed: boolean;
  toggleSidebarCollapse: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SidebarContext = createContext<SidebarContext>(
  {} as SidebarContext
);

export const SidebarProvider: FC = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <SidebarContext.Provider value={{ 
      sidebarToggle, 
      toggleSidebar,
      sidebarCollapsed,
      toggleSidebarCollapse
    }}>
      {children}
    </SidebarContext.Provider>
  );
};
